import { Dispatch } from "react";
import { GETAPI, POSTAPI, PATCHAPI, DELETEAPI } from "../../API/Api";
import { ApiConfig } from "../../Config/CommonConfig";
import * as C from "../../Constants/PricingConstants";

// A list thunk: GET base + optional query-string. Stores the (array) payload.
const makeListAction =
  (base: string, REQ: string, OK: string, FAIL: string) =>
  (qs = "") =>
  async (dispatch: Dispatch<any>) => {
    dispatch({ type: REQ });
    const res = await GETAPI(base + qs);
    dispatch(
      res?.status === true
        ? { type: OK, data: res.data }
        : { type: FAIL, data: [] }
    );
    return res;
  };

// create/update/remove thunks sharing one MUTATE channel.
const makeMutateActions = (
  base: string,
  REQ: string,
  OK: string,
  FAIL: string
) => ({
  create: (body: any) => async (dispatch: Dispatch<any>) => {
    dispatch({ type: REQ });
    const res = await POSTAPI(base, body);
    dispatch(res?.status === true ? { type: OK, data: res.data } : { type: FAIL });
    return res;
  },
  update: (id: number, body: any) => async (dispatch: Dispatch<any>) => {
    dispatch({ type: REQ });
    const res = await PATCHAPI(`${base}${id}/`, body);
    dispatch(res?.status === true ? { type: OK, data: res.data } : { type: FAIL });
    return res;
  },
  remove: (id: number) => async (dispatch: Dispatch<any>) => {
    dispatch({ type: REQ });
    const res = await DELETEAPI(`${base}${id}/`);
    dispatch(res?.status === true ? { type: OK, data: res.data } : { type: FAIL });
    return res;
  },
});

// --- Feature Catalog ---
export const FeatureCatalogListAction = makeListAction(
  ApiConfig.FeatureCatalogBase,
  C.FEATURE_CATALOG_LIST_REQUEST,
  C.FEATURE_CATALOG_LIST_SUCCESS,
  C.FEATURE_CATALOG_LIST_FAIL
);
const featureCatalog = makeMutateActions(
  ApiConfig.FeatureCatalogBase,
  C.FEATURE_CATALOG_MUTATE_REQUEST,
  C.FEATURE_CATALOG_MUTATE_SUCCESS,
  C.FEATURE_CATALOG_MUTATE_FAIL
);
export const FeatureCatalogCreateAction = featureCatalog.create;
export const FeatureCatalogUpdateAction = featureCatalog.update;
export const FeatureCatalogDeleteAction = featureCatalog.remove;

// --- Calculator Presets ---
export const CalculatorPresetListAction = makeListAction(
  ApiConfig.CalculatorPresetBase,
  C.CALCULATOR_PRESET_LIST_REQUEST,
  C.CALCULATOR_PRESET_LIST_SUCCESS,
  C.CALCULATOR_PRESET_LIST_FAIL
);
const calculatorPreset = makeMutateActions(
  ApiConfig.CalculatorPresetBase,
  C.CALCULATOR_PRESET_MUTATE_REQUEST,
  C.CALCULATOR_PRESET_MUTATE_SUCCESS,
  C.CALCULATOR_PRESET_MUTATE_FAIL
);
export const CalculatorPresetCreateAction = calculatorPreset.create;
export const CalculatorPresetUpdateAction = calculatorPreset.update;
export const CalculatorPresetDeleteAction = calculatorPreset.remove;

// --- Top-up Presets ---
export const TopupPresetListAction = makeListAction(
  ApiConfig.TopupPresetBase,
  C.TOPUP_PRESET_LIST_REQUEST,
  C.TOPUP_PRESET_LIST_SUCCESS,
  C.TOPUP_PRESET_LIST_FAIL
);
const topupPreset = makeMutateActions(
  ApiConfig.TopupPresetBase,
  C.TOPUP_PRESET_MUTATE_REQUEST,
  C.TOPUP_PRESET_MUTATE_SUCCESS,
  C.TOPUP_PRESET_MUTATE_FAIL
);
export const TopupPresetCreateAction = topupPreset.create;
export const TopupPresetUpdateAction = topupPreset.update;
export const TopupPresetDeleteAction = topupPreset.remove;

// --- Top-up Bonus Rules ---
export const TopupBonusRuleListAction = makeListAction(
  ApiConfig.TopupBonusRuleBase,
  C.TOPUP_BONUS_RULE_LIST_REQUEST,
  C.TOPUP_BONUS_RULE_LIST_SUCCESS,
  C.TOPUP_BONUS_RULE_LIST_FAIL
);
const topupBonusRule = makeMutateActions(
  ApiConfig.TopupBonusRuleBase,
  C.TOPUP_BONUS_RULE_MUTATE_REQUEST,
  C.TOPUP_BONUS_RULE_MUTATE_SUCCESS,
  C.TOPUP_BONUS_RULE_MUTATE_FAIL
);
export const TopupBonusRuleCreateAction = topupBonusRule.create;
export const TopupBonusRuleUpdateAction = topupBonusRule.update;
export const TopupBonusRuleDeleteAction = topupBonusRule.remove;

// --- Currency Credit Rates ---
export const CurrencyCreditRateListAction = makeListAction(
  ApiConfig.CurrencyCreditRateBase,
  C.CURRENCY_CREDIT_RATE_LIST_REQUEST,
  C.CURRENCY_CREDIT_RATE_LIST_SUCCESS,
  C.CURRENCY_CREDIT_RATE_LIST_FAIL
);
const currencyCreditRate = makeMutateActions(
  ApiConfig.CurrencyCreditRateBase,
  C.CURRENCY_CREDIT_RATE_MUTATE_REQUEST,
  C.CURRENCY_CREDIT_RATE_MUTATE_SUCCESS,
  C.CURRENCY_CREDIT_RATE_MUTATE_FAIL
);
export const CurrencyCreditRateCreateAction = currencyCreditRate.create;
export const CurrencyCreditRateUpdateAction = currencyCreditRate.update;
export const CurrencyCreditRateDeleteAction = currencyCreditRate.remove;

// --- Charge Sync (preview = GET, apply = POST) ---
export const ChargeSyncPreviewAction =
  () => async (dispatch: Dispatch<any>) => {
    dispatch({ type: C.CHARGE_SYNC_PREVIEW_REQUEST });
    const res = await GETAPI(ApiConfig.ChargeSyncBase);
    dispatch(
      res?.status === true
        ? { type: C.CHARGE_SYNC_PREVIEW_SUCCESS, data: res.data }
        : { type: C.CHARGE_SYNC_PREVIEW_FAIL }
    );
    return res;
  };

export const ChargeSyncApplyAction = () => async (dispatch: Dispatch<any>) => {
  dispatch({ type: C.CHARGE_SYNC_APPLY_REQUEST });
  const res = await POSTAPI(ApiConfig.ChargeSyncBase, {});
  dispatch(
    res?.status === true
      ? { type: C.CHARGE_SYNC_APPLY_SUCCESS, data: res.data }
      : { type: C.CHARGE_SYNC_APPLY_FAIL }
  );
  return res;
};
